module.exports = __webpack_public_path__ + "img/personal-hover.cb3eb436.svg";